import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../context/UserContext';
import { Rest } from '../../../util/rest';
import { scoreWphi } from '../utils/wphi';

export function useWphiData(assignmentId) {
 const {user} = useContext(UserContext);
 const [state,setState] = useState({status:'loading'});
 useEffect(()=>{
  let active = true;
  setState({status:assignmentId ? 'loading' : 'absent'});
  if (!assignmentId) return;
  async function load() {
   try {
    const assessment = await Rest.authFetch(user, `/rest/assessment/${assignmentId}`);
    if (!active) return;
    let template = assessment.template;
    if (!template) {
     if (!assessment.assignable?.id) throw new Error('Missing template');
     template = await Rest.authFetch(user, `/rest/assessment/templates/${assessment.assignable.id}`);
    }
    if (active) setState(scoreWphi(template,assessment.answers));
   } catch (_) {
    if (active) setState({status:'error'});
   }
  }
  load();
  return ()=>{active=false;};
 },[assignmentId,user]);
 return state;
}
